import React from "react";
import "../styles/PaymentPopup.css";

const PaymentPopup = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <h2>무통장 입금 안내</h2>
                <p>다음 계좌가 지원됩니다.</p>
                <br />
                <ul>
                    <li>📌 기업은행: 011-139191-01-018</li>
                    <li>📌 우리은행: 1005-204-707641</li>
                    <p>예금주: 박찬엽(소프트캣)</p>
                </ul>
                <br/>
                <button className="close-btn" onClick={onClose}>확인</button>
            </div>
        </div>
    );
};

export default PaymentPopup;
